import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './util/didomiConfig';
import './util/analyticsConsent';
import ConnectedApp from './App';
import store from './store';

const Main = (
  <Provider store={store}>
    <Router>
      <ConnectedApp />
    </Router>
  </Provider>
);

ReactDOM.render(Main, document.getElementById('root'));
